<template>
  <div class="yk-ap-que-file-wrapper">
      <div>
        <el-table
          :data="questionFiles"
            stripe
          style="width: 100%" class="yk-table-dark-questionBankFile"
          :show-header="false">
          <el-table-column
            width="180">
              <template slot-scope="scope">
                  <i class="wl-icon-fujian" style="margin-left:50px;"></i>
              </template>
          </el-table-column>
          <el-table-column
            prop="name"
           >
          </el-table-column>
          <el-table-column width="100">
             <template slot-scope="scope">
              <el-button
                size="mini" @click="handlePreview(scope.row.docId)" title="查看" type="primary">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
       <!--课件预览-->
      <div class="PreviewResourcces-questionFile" v-show="dialogVisiblePreviewResources">
        <!-- <i @click="dialogClose()" style="color:red;font-size:35px" class="el-icon-close icon-closeimg"></i> -->
        <PreparingCourseware v-if="dialogVisiblePreviewResources" :sourceId="docId" :savesession="false" @dialogVisiblePreviewResources="dialogClose()"></PreparingCourseware>
      </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import uploader from 'lib/mixins/uploader';
import PreparingCourseware from 'components/PreparingCourseware.vue';
export default {
  name: 'oss-question-file',
  components: {
    PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: ''
    },
    filesList: {
      type: Array,
      default: {
        Id: String,
        DocTitle: String,
        DocUrl: String
      }
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.questionFiles = [];
    this.filesList.forEach(element => {
      this.questionFiles.push({
        name: element.DocTitle,
        url: element.DocUrl,
        docId: element.Id
      });
      this.fileIds.push(element.Id);
    });
  },
  data() {
    return {
      questionFiles: [],
      sourceUrl: {
        id: '',
        url: '',
        type: '',
        docName: '',
        docType: 0
      },
      docId: '',
      dialogVisiblePreviewResources: false
    };
  },
  watch: {
    filesList: function(val) {
      this.questionFiles = [];
      val.forEach(element => {
        this.questionFiles.push({
          name: element.DocTitle,
          url: element.DocUrl,
          docId: element.Id
        });
        this.fileIds.push(element.Id);
      });
    }
  },
  methods: {
    beforeUpload(file) {
      return this.addFile(file);
    },
    onRemoveHandler(file) {
      this.questionFiles = this.questionFiles.filter(
        p => p.docId !== file.docId
      );
      this.fileIds = this.fileIds.filter(p => p !== file.docId);
      this.$emit('update:fileIds', this.fileIds);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    handlePreview(docId) {
      this.dialogVisiblePreviewResources = true;
      this.docId = docId;
    },
    onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      this.questionFiles.push({
        name: file.name,
        url: res.docPath,
        docId: res.docId
      });
      this.fileIds.push(res.docId);
      this.$emit('update:fileIds', this.fileIds);
    }
  }
};
</script>
<style lang="scss">
.yk-ap-que-file-wrapper {
  .yk-table-dark-questionBankFile {
    border-radius: 10px;
    &.el-table {
      background-color: inherit;
      &:before {
        background-color: inherit;
      }
      th {
        background-color: white;
        color: #3c4c66;
      }
      tr,
      td {
        background-color: white;
        color: #3c4c66;
      }
      td,
      th.is-leaf {
        border-bottom: 0;
      }
    }
    &.el-table--enable-row-hover {
      .el-table__body {
        tr {
          &:hover {
            > td {
              background-color: silver;
            }
          }
        }
      }
    }
  }
}
.PreviewResourcces-questionFile {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 5%;
  .icon-closeimg {
    size: 26px;
    position: fixed;
    right: 20px;
    bottom: 100px;
    cursor: pointer;
    font-weight: bolder;
  }
}
</style>
